// Las escenas 3D solo usan WebGL si hay aceleración gráfica. Sin ella (sin driver de video, o con la GPU desactivada en
// Chrome) WebGL corre por software: va lento y en una PC de sala con Chrome 156 la app se caía con
// STATUS_ACCESS_VIOLATION. Con esta opción el navegador no crea el contexto y cada escena muestra su imagen de respaldo.
export const WEBGL_HARDWARE_ONLY = { failIfMajorPerformanceCaveat: true };

let hardware;

// three.js, si no obtiene el contexto con WEBGL_HARDWARE_ONLY, lo vuelve a pedir sin opciones solo para elegir el
// mensaje de error, y eso crea igual un contexto por software. Por eso se pregunta antes, con un canvas de prueba.
export function hasHardwareWebGL() {
  if (hardware === undefined) {
    const canvas = document.createElement('canvas');
    let gl = null;
    try {
      gl = canvas.getContext('webgl2', WEBGL_HARDWARE_ONLY) || canvas.getContext('webgl', WEBGL_HARDWARE_ONLY);
    } catch {
      // Un navegador sin canvas cuenta como sin WebGL.
    }
    hardware = Boolean(gl);
    gl?.getExtension('WEBGL_lose_context')?.loseContext();
  }
  return hardware;
}

export function requireHardwareWebGL() {
  if (!hasHardwareWebGL()) throw new Error('WebGL sin aceleración gráfica');
}
